import { html, render } from 'lit-html'
import BEM from '@polleverywhere/toolkit-lib/lib/mixins/_bem'
import RecentList from './list'
import recentIcon from './recent.svg'
import closeIcon from './close.svg'
import './style.scss'
import { recentPresentations } from '../../../states/participant/util/recentPresentations'
import { cutlassEvent } from '@polleverywhere/cutlass'

export default class Recent extends Backbone.View {
  get className () { return 'pollev-home__recent' }

  initialize () {
    _.extend(this, BEM(this))

    this.list = new RecentList()

    this.listenTo(this.list, 'join', (username, exists) => {
      this.trigger('join', username, exists)
      cutlassEvent(this.el, 'join_recent', { successful: exists })
    })
  }

  render () {
    if (recentPresentations.list().length) {
      render(html`
        <h2 class="pollev-home__recent__header">Recent presentations</h2>
        <pe-button class="pollev-home__recent__toggle" title="Toggle recent" id="aria-pollev-recent-toggle" aria-haspopup="true" aria-controls="aria-pollev-recent-list" @click=${() => this.toggle()}>
          ${html([recentIcon, closeIcon])}
        </pe-button>
        ${this.list.render().el}
      `, this.el)

      this.toggle(false)
    }

    return this
  }

  toggle (state = undefined) {
    const nowOpen = state ?? !this.$_hasModifier(null, this.className, 'open')
    this.$_toggleModifier(null, this.className, 'open', nowOpen)
    this.$_element('toggle').attr('aria-expanded', nowOpen)
  }

  remove () {
    this.list.remove()
    return super.remove()
  }
}
